import { render } from "./VideosView.vue?vue&type=template&id=aaac3ff4&scoped=true"
import script from "./VideosView.vue?vue&type=script&lang=js"
export * from "./VideosView.vue?vue&type=script&lang=js"

import "./VideosView.vue?vue&type=style&index=0&id=aaac3ff4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaac3ff4"]])

export default __exports__